import React from "react";

import MainTemplate from "@/components/Templates/MainTemplate";
import OfferPageUI from "./OfferPageUI";

import { Container, Wrapper } from "./Style";

function OfferPage() {
  return (
    <MainTemplate hideRibbon>
      <Wrapper>
        <Container>
          <OfferPageUI offerPageData={offerPageData} />
        </Container>
      </Wrapper>
    </MainTemplate>
  );
}

export default OfferPage;

const offerPageData = {
  heading: "Exciting Offers",
  subHeading:
    "Exciting offers available with our partners at discounted prices",
  categoriesData: [{}, {}],
  topicData: [{}, {}],
  offersData: [
    // {
    //   productDetail:
    //     "Offering a wide range of supplements to manage your hormones and PCOS symptoms which can also aid in healthy ovulation and regularizing your menstrual cycles.",
    //   offerPromoCode: "SHYFT10",
    //   discountPercentage: "10",
    //   logoUrl:
    //     "https://d1mxd7n691o8sz.cloudfront.net/static/offers-page/content/drmorepenlogo.png",
    //   bannerImageUrl:
    //     "https://d1mxd7n691o8sz.cloudfront.net/static/offers-page/content/shyft-banners-PCOS.png",
    //   productWebPageUrl: "health.drmorepen.com",
    //   partnerName: "Dr. Morepen",
    //   redirectPageLink:
    //     "https://health.drmorepen.com/product/pcos-supplement-powder",
    //   offerValidityDate: "30 Nov. 2022",
    // },
    {
      productDetail:
        "Offering a wide range of wellness-based health supplements especially for men",
      offerPromoCode: "SHYFT10",
      discountPercentage: "10",
      logoUrl:
        "https://d1mxd7n691o8sz.cloudfront.net/static/offers-page/content/drmorepenlogo.png",
      bannerImageUrl:
        "https://d1mxd7n691o8sz.cloudfront.net/static/offers-page/content/shyft-banners-MEN-625px-X-169px.png",
      productWebPageUrl: "health.drmorepen.com",
      partnerName: "Dr. Morepen",
      redirectPageLink: "https://health.drmorepen.com/shop/",
      offerValidityDate: "30 Nov. 2022",
    },
    {
      productDetail:
        "Offering a wide range of wellness-based health supplements, especially for women's health",
      offerPromoCode: "SHYFT10",
      discountPercentage: "10",
      logoUrl:
        "https://d1mxd7n691o8sz.cloudfront.net/static/offers-page/content/drmorepenlogo.png",
      bannerImageUrl:
        "https://d1mxd7n691o8sz.cloudfront.net/static/offers-page/content/shyft-banners-WOMEN.png",
      productWebPageUrl: "health.drmorepen.com",
      partnerName: "Dr. Morepen",
      redirectPageLink: "https://health.drmorepen.com/shop/",
      offerValidityDate: "30 Nov. 2022",
    },
  ],
  moreOffersLogoUrl: [
    "https://d1mxd7n691o8sz.cloudfront.net/static/offers-page/content/drmorepenlogo.png",
    "https://d1mxd7n691o8sz.cloudfront.net/static/offers-page/content/drmorepenlogo.png",
    "https://d1mxd7n691o8sz.cloudfront.net/static/offers-page/content/drmorepenlogo.png",
    "https://d1mxd7n691o8sz.cloudfront.net/static/offers-page/content/drmorepenlogo.png",
  ],
};
